<template>
  <navbar
    position="fixed"
    type="primary"
    :color-on-scroll="colorOnScroll"
    menu-classes="ml-auto"
  >
    <template slot-scope="{ toggle, isToggled }">
        <img class="loyalty-logo" src="../assets/assets_loyalty/assets-19.png">
    </template>
    <template slot="navbar-menu">
      <li class="welcome">
          <p>Bienvenido de nuevo, <strong>{{userData.nombre}}</strong></p>
      </li>
      <li class="nav-item">
        <nav-link to="/login">
        <n-button @click="logOut()" type="info" class="nav-link" round>
            <p>Cerrar Sesión</p>
        </n-button>
        </nav-link>
      </li>
    </template>
  </navbar>
</template>

<script>
import { DropDown, NavbarToggleButton, Navbar, NavLink, Button} from '@/components';
import { Popover } from 'element-ui';
import ProfileService from '../service/core/profile.service'

export default {
  name: 'main-navbar',
  props: {
    transparent: Boolean,
    colorOnScroll: Number
  },
  data(){
    return {
      profileService: new ProfileService(),
      userData: '',
    }
  },
  components: {
    DropDown,
    Navbar,
    NavbarToggleButton,
    NavLink,
    [Popover.name]: Popover,
    [Button.name]: Button
  },
  mounted(){
      this.profileService.account().then(data => {
          this.userData = data.data.result
      }, err => {
      })
  },
  methods: {
    scrollMeTo(refName) {
      var element = this.$refs[refName];
      var top = element.offsetTop;

      window.scrollTo(0, top);
    },
    logOut(){
      sessionStorage.removeItem('accountTk');
      console.log(localStorage.getItem('Validar')); // retrieve the item
      sessionStorage.removeItem('Validar');
    }
  }
};
</script>

<style scoped>
.navbar-titles{
  color: black;
  font-weight: bold;
}
.loyalty-logo{
  width: 200px;
}
.welcome{
    color: black;
    margin: 15px;
}
</style>
